// Constantes de dominio compartilhadas entre backend e frontend.
// A fonte da verdade do MODELO DE DADOS continua sendo apps/backend/src/db/schema.ts;
// um teste no backend garante que estas listas nao divirjam dos enums do banco.
import { z } from "zod";
export const LANGUAGES = ["PYTHON", "JAVA", "C", "CPP", "JAVASCRIPT"];
export const languageSchema = z.enum(LANGUAGES);
export const VERDICTS = ["AC", "WA", "TLE", "MLE", "RE", "CE"];
export const verdictSchema = z.enum(VERDICTS);
export const SUBMISSION_STATUSES = [
    "QUEUED",
    "JUDGING",
    "DONE",
    "INTERNAL_ERROR",
];
export const submissionStatusSchema = z.enum(SUBMISSION_STATUSES);
export const CONTEST_STATUSES = ["DRAFT", "RUNNING", "PAUSED", "ENDED"];
export const contestStatusSchema = z.enum(CONTEST_STATUSES);
/** Vereditos que contam como tentativa errada (CE e INTERNAL_ERROR nao penalizam). */
export const PENALIZED_VERDICTS = ["WA", "TLE", "MLE", "RE"];
export function isPenalized(v) {
    return PENALIZED_VERDICTS.includes(v);
}
/** Rotulo legivel por linguagem, usado no seletor do editor. */
export const LANGUAGE_LABEL = {
    C: "C (GCC 9.2)",
    CPP: "C++ (GCC 9.2)",
    JAVA: "Java (OpenJDK 13)",
    JAVASCRIPT: "JavaScript (Node.js 12)",
    PYTHON: "Python (3.8)",
};
/** Tamanho maximo do codigo-fonte, em bytes (espelha o CHECK da tabela submissions). */
export const MAX_SOURCE_CODE_BYTES = 64 * 1024;
//# sourceMappingURL=domain.js.map